<template>
  <Dialog
    :model="showAlertPop"
    :closeable="false"
    @alertOnClose="closeMe"
  >
    <span class="alert-title">温馨提示</span>
    <article class="alert-content">
      {{ alertMessage }}
    </article>
    <div v-if="canWithdraw.usdt || canWithdraw.bank" class="alert-bottom">
      <button type="button" class="alert-button" @click="continueWithdraw">
        继续{{ canWithdraw.bank ? '银行卡' : canWithdraw.usdt ? '电子钱包' : '' }}取款
      </button>
      <button type="button" class="alert-button alert-cancel" @click="goBack">
        返回上一页
      </button>
    </div>
    <div v-else class="alert-bottom">
      <button type="button" class="alert-button alert-cancel" @click="goBack">
        返回上一页
      </button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/view/module/Dialog.vue'
import { mapState } from 'vuex'

export default {
  name: 'NewCanWithdrawalModule',
  components: {
    Dialog
  },
  props: ['showAlertPop', 'alertOnClose', 'canWithdraw'],
  data() {
    return {}
  },
  computed: {
    ...mapState(['pageType']),
    alertMessage() {
      if (!this.canWithdraw.bank && !this.canWithdraw.usdt) {
        return '目前非电子钱包和银行卡取款开放时间， 如有需要可联系我司24小时客服。'
      } else if (this.canWithdraw.bank && !this.canWithdraw.usdt) {
        return '目前非电子钱包取款开放时间， 如有需要可联系我司24小时客服。'
      } else if (!this.canWithdraw.bank && this.canWithdraw.usdt) {
        return '目前非银行卡取款开放时间， 如有需要可联系我司24小时客服。'
      }
      
      // Fallback message just in case the popup is shown when both are true
      return '目前非取款开放时间， 如有需要可联系我司24小时客服。'
    }
  },
  methods: {
    continueWithdraw() {
      this.$emit('alertOnClose')
    },
    closeMe() {
      this.$emit('alertOnClose')
    },
    goBack() {
      // Check if pageType is 'app' to trigger native app close logic
      if (this.pageType === 'app') {
        const u = navigator.userAgent
        const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

        try {
          let v
          if (isIOS) {
            if (typeof (window.closeAction) != 'undefined') {
              v = window.closeAction()
            } else {
              v = window.webkit.messageHandlers.closeAction.postMessage(null)
            }
          } else {
            v = window.uiObject.closeAction()
          }
        } catch (e) {
          alert(e)
        }
      } else {
        // Fall back to original logic if pageType is anything else
        this.$router.replace({ path: '/home' })
      }
    }
  }
}
</script>